import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=984f574a&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
import style0 from "./Team.vue?vue&type=style&index=0&id=984f574a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984f574a",
  null
  
)

export default component.exports